if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const formData = new FormData(this.form);

      console.log(formData);
      const body = Object.fromEntries(formData.entries());

      liquidAjaxCart.add(body, {
        firstCallback: (requestState) => {
          // Handle immediate response logic here
        },
        lastCallback: (requestState) => {

          // handleErrorMessage

          // Liquid Ajax Cart update
          // if (requestState.response.status) {
          //   // Handle error
          //   this.handleErrorMessage(requestState.response.description);
          // } else {
          //   // Handle success
          //   if (this.cart) {
          //     this.cart.renderContents(requestState.response);
          //   }
          // }

          // Reset the button state and other UI elements
          const delay = (duration) => new Promise(resolve => setTimeout(resolve, duration));

          delay(100).then(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });          
        }
      });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}